import createDataContext from './createDataContext';
import { api } from '../api/api';

const reducer = (state, action) => {
  switch (action.type) {
    case 'LOAD_REQUEST':
      return {
        ...state,
        loading: true,
        error: false,
        listicle: null,
      };
    case 'UPDATE_REQUEST':
      return {
        ...state,
        updating: true,
        error: false,
      };
    case 'SUCCESS':
      return {
        ...state,
        loading: false,
        updating: false,
        listicle: action.payload,
      };
    case 'ERROR':
      return {
        ...state,
        loading: false,
        updating: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

const loadListicle = (dispatch) => async (id) => {
  try {
    dispatch({
      type: 'LOAD_REQUEST',
    });
    const response = await api.get(`/listicles/${id}`, {});
    dispatch({
      type: 'SUCCESS',
      payload: response.data,
    });
  } catch (e) {
    dispatch({
      type: 'ERROR',
      payload: 'Unable to load listicle.',
    });
  }
};

const updateListicle = (dispatch) => async (id, data) => {
  try {
    dispatch({
      type: 'UPDATE_REQUEST',
    });
    const response = await api.patch(`/listicles/${id}`, data, {});
    dispatch({
      type: 'SUCCESS',
      payload: response.data,
    });
  } catch (e) {
    dispatch({
      type: 'ERROR',
      payload: 'Unable to update listicle.',
    });
  }
};

const createListicle = (dispatch) => async (data) => {
  try {
    dispatch({
      type: 'REQUEST',
    });
    const response = await api.post(`/listicles`, data, {});
    dispatch({
      type: 'SUCCESS',
      payload: response.data,
    });

    return response.data;
  } catch (e) {
    dispatch({
      type: 'ERROR',
      payload: 'Unable to create listicle.',
    });
  }
};

const deleteListicle = (dispatch) => async (id) => {
  try {
    dispatch({
      type: 'REQUEST',
    });
    const response = await api.delete(`/listicles/${id}`, {});
    dispatch({
      type: 'SUCCESS',
      payload: response.data,
    });
  } catch (e) {
    dispatch({
      type: 'ERROR',
      payload: 'Unable to delete listicle.',
    });
  }
};

export const { Context, Provider } = createDataContext(
  reducer,
  {
    loadListicle,
    createListicle,
    updateListicle,
    deleteListicle,
  },
  {
    listicle: null,
    error: '',
    loading: false,
    updating: false,
  }
);
